import React from "react";
import "../styles/sidebar.css";
import NavbarCollapseButton from "./NavbarCollapseButton";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import me from "../images/introduction/me1.jpg";
import M from "materialize-css/dist/js/materialize.min";
import {
  faAward,
  faCode,
  faCodeBranch,
  faHistory,
  faUser,
  faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";

const MENU_LIST = [
  ["About", faUser, "teal-text"],
  ["Experience", faHistory, "indigo-text"],
  ["Projects", faCodeBranch, "purple-text"],
  ["Skills", faCode, "orange-text"],
  ["Education", faUserGraduate, "cyan-text"],
  ["Awards", faAward, "blue-text"],
  ["Contact", faUser, "yellow-text"],
];

class Sidebar extends React.Component {
  getMenuItems = () => {
    var menuItems = [];
    menuItems.push("Introduction");
    for (const item of MENU_LIST) {
      menuItems.push(item[0]);
    }
    return menuItems;
  };
  componentDidMount() {
    const elem = document.querySelectorAll(".materialboxed");
    M.Materialbox.init(elem, {});
  }
  render() {
    const fixedSidebarItems = [];

    for (const item of MENU_LIST) {
      fixedSidebarItems.push(
        <li key={item[0]}>
          <a
            href={"#" + item[0]}
            className={item[2] + " waves-effect waves-green menu-item"}
          >
            <FontAwesomeIcon icon={item[1]}></FontAwesomeIcon>
            <span>{item[0]}</span>
          </a>
        </li>
      );
    }

    const collapseSidebarItems = [];

    for (const item of MENU_LIST) {
      collapseSidebarItems.push(
        <li key={item[0]}>
          <a
            href={"#" + item[0]}
            className="waves-effect waves-green toggle-menu-item black-text"
          >
            <FontAwesomeIcon icon={item[1]}></FontAwesomeIcon>
            <span>{item[0]}</span>
          </a>
        </li>
      );
    }

    return (
      <div>
        <NavbarCollapseButton />

        <nav className="hide-on-small-only">
          <ul className="sidenav sidenav-fixed section table-of-contents">
            <li className="logo user-view">
              <img
                style={{ display: "block", margin: "0 auto" }}
                className=" materialboxed circle  responsive-img  dude-pic"
                src={me}
                alt="Me"
              />
              <a href="#Introduction" className="logo-name green-text">
                <h1>J Keerthi</h1>
              </a>
              <a href="#Introduction" className="logo-name-desc brown-text">
                Full Stack Developer
              </a>
            </li>
            {fixedSidebarItems}
            {/*<Resume menu_class={"menu-item"}/>*/}
          </ul>
        </nav>

        <nav className="hide-on-large-only disable-navbar">
          <ul id="slide-out" className="sidenav sidenav-activate">
            {collapseSidebarItems}
            {/*<Resume menu_class={"toggle-menu-item"}/>*/}
          </ul>
        </nav>
      </div>
    );
  }
}

export default Sidebar;
